module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.5@core-js/modules/_function-to-string.js
// module id = 295
// module chunks = 0